import { useEffect } from "react";

/**
 * Lightweight per-page SEO hook — sets <title>, <meta name="description">,
 * canonical URL, and Open Graph / Twitter tags without adding a dependency.
 */
export default function useSeo({ title, description, path, image, type = "website" } = {}) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (attr, name, content) => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    const setLink = (rel, href) => {
      if (!href) return;
      let el = document.head.querySelector(`link[rel="${rel}"]`);
      if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
      }
      el.setAttribute("href", href);
    };

    const canonical = path ? `https://beaudesertgp.com.au${path}` : "https://beaudesertgp.com.au/";

    setMeta("name", "description", description);
    setLink("canonical", canonical);

    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", canonical);
    setMeta("property", "og:type", type);
    if (image) setMeta("property", "og:image", image);

    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    if (image) setMeta("name", "twitter:image", image);
  }, [title, description, path, image, type]);
}
